import { Helmet } from "react-helmet-async";
import { ChevronDown } from "lucide-react";
import RichText, { stripLinks } from "./RichText";

// Plain <details> keeps every answer in the page HTML (good for crawlers and
// works without JavaScript); the FAQPage markup mirrors the same questions.
export default function FAQSection({
  title = "Frequently asked questions",
  items = [],
  tone = "white",
  markup = true,
}) {
  if (!items.length) return null;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: stripLinks(item.a) },
    })),
  };

  return (
    <section className={tone === "pink" ? "bg-[#fff7fb]" : "bg-white"}>
      {markup && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        </Helmet>
      )}

      <div className="mx-auto max-w-4xl px-6 py-16 sm:px-10 md:py-20 lg:px-16 xl:px-6">
        <div className="text-center">
          <p className="text-sm uppercase tracking-[0.3em] text-pink-500/80">
            FAQ
          </p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-black md:text-4xl">
            {title}
          </h2>
        </div>

        <div className="mt-10 space-y-3">
          {items.map((item) => (
            <details
              key={item.q}
              className="group rounded-2xl border border-black/10 bg-white shadow-[0_8px_24px_rgba(0,0,0,0.04)] open:border-pink-300"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-6 py-5 text-left text-base font-semibold text-black [&::-webkit-details-marker]:hidden">
                {item.q}
                <ChevronDown
                  size={20}
                  className="shrink-0 text-pink-600 transition group-open:rotate-180"
                  aria-hidden="true"
                />
              </summary>
              <p className="px-6 pb-5 text-[15px] leading-relaxed text-black/70">
                <RichText>{item.a}</RichText>
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
